import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateClientMutationVariables = Types.Exact<{
  data: Types.CreateClientInput;
}>;


export type CreateClientMutation = { createClient?: { client?: { id: string, clientName: string } | null } | null };


export const CreateClientDocument = /*#__PURE__*/ gql`
    mutation CreateClient($data: CreateClientInput!) {
  createClient(data: $data) {
    client {
      id
      clientName
    }
  }
}
    `;

export function useCreateClientMutation() {
  return Urql.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument);
};